import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { Fund } from '../api/types'
import { useOpsApi } from '../api/context'
import { useCurrentUser } from '../auth'
import { PageHeader } from '../components/PageHeader'
import { InternalAccountsCard } from './jednotky/InternalAccountsCard'

/**
 * Nastavení modulu (CEO). Nahradilo záložku Start modulu (Michal 22. 10.). Jednorázové kroky
 * startu (importy, dorovnání na Excel) i hlavní vypínač e-mailů odpadly — o každém e-mailu
 * rozhoduje zaškrtávátko u konkrétní akce. Zůstaly účty Apexu (success fee, opravná položka).
 */
export function NastaveniPhase() {
  const api = useOpsApi()
  const user = useCurrentUser()
  const [funds, setFunds] = useState<Fund[]>([])

  useEffect(() => {
    api.listFunds().then(setFunds).catch(() => undefined)
  }, [api])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <PageHeader title="Nastavení" subtitle="Účty Apexu pro success fee a opravnou položku." />
      <InternalAccountsCard canEdit={user.isCeo} funds={funds} showSurplus={false} />
    </Box>
  )
}
